export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
